// extracted by mini-css-extract-plugin
export default {"container":"FloatingNotification_container","notification":"FloatingNotification_notification","text":"FloatingNotification_text"};